/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamDisciplineDropdownFilteredQueryResponse,
  GetApiV1ExamDisciplineDropdownFilteredQueryParams,
  GetApiV1ExamDisciplineDropdownFiltered400,
  GetApiV1ExamDisciplineDropdownFiltered401,
  GetApiV1ExamDisciplineDropdownFiltered500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamDisciplineDropdownFiltered.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamDisciplineDropdownFiltered } from "../../clients/examQuestionLibraryController/getApiV1ExamDisciplineDropdownFiltered.ts";

export const getApiV1ExamDisciplineDropdownFilteredQueryKey = (
  params?: GetApiV1ExamDisciplineDropdownFilteredQueryParams,
) =>
  [
    { url: "/api/v1/exam/discipline-dropdown-filtered" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamDisciplineDropdownFilteredQueryKey = ReturnType<
  typeof getApiV1ExamDisciplineDropdownFilteredQueryKey
>;

export function getApiV1ExamDisciplineDropdownFilteredQueryOptions(
  params?: GetApiV1ExamDisciplineDropdownFilteredQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamDisciplineDropdownFilteredQueryKey(params);
  return queryOptions<
    GetApiV1ExamDisciplineDropdownFilteredQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamDisciplineDropdownFiltered400
      | GetApiV1ExamDisciplineDropdownFiltered401
      | GetApiV1ExamDisciplineDropdownFiltered500
    >,
    GetApiV1ExamDisciplineDropdownFilteredQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamDisciplineDropdownFiltered(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista de disciplinas ativas para uso em componentes de seleção, com filtros opcionais por modalidade do curso, empresa, curso, sala de aula e texto. Quando classroomId é informado, retorna apenas disciplinas cuja modalidade corresponde ao tipo da sala de aula. Quando bringMain é verdadeiro, inclui disciplinas globais junto às disciplinas da empresa. **(Requer Authorization para autenticação)**
 * @summary Lista de disciplinas filtrada para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/discipline-dropdown-filtered}
 */
export function useGetApiV1ExamDisciplineDropdownFiltered<
  TData = GetApiV1ExamDisciplineDropdownFilteredQueryResponse,
  TQueryData = GetApiV1ExamDisciplineDropdownFilteredQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamDisciplineDropdownFilteredQueryKey,
>(
  params?: GetApiV1ExamDisciplineDropdownFilteredQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamDisciplineDropdownFilteredQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamDisciplineDropdownFiltered400
          | GetApiV1ExamDisciplineDropdownFiltered401
          | GetApiV1ExamDisciplineDropdownFiltered500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamDisciplineDropdownFilteredQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamDisciplineDropdownFilteredQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamDisciplineDropdownFiltered400
      | GetApiV1ExamDisciplineDropdownFiltered401
      | GetApiV1ExamDisciplineDropdownFiltered500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
